export default function ProjectCard({ project, onClick }) {
	return (
		<div
			onClick={onClick}
			onMouseEnter={(e) => {
				e.currentTarget.style.transform = "translateY(-4px)";
				e.currentTarget.style.boxShadow = `0 0 20px ${project.borderColor}`;
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.transform = "translateY(0)";
				e.currentTarget.style.boxShadow = `0 0 10px ${project.borderColor}`;
			}}
			style={{
				borderColor: project.borderColor,
				boxShadow: `0 0 10px ${project.borderColor}`,
			}}
			className="group relative cursor-pointer bg-gray-800 text-white rounded-lg p-5 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 border-4 transition-all duration-300 text-center sm:text-left"
		>
			{/* Platform Icons - Top Right */}
			<div className="absolute top-3 right-3 flex gap-2 sm:gap-3 z-10 transition-transform duration-300 group-hover:-translate-y-1">
				{project.platforms?.includes("steam") && (
					<img src="/icons/steam.png" alt="Steam" className="w-8 h-8 sm:w-12 sm:h-12" title="Steam" />
				)}
				{project.platforms?.includes("itch") && (
					<img src="/icons/itch.svg" alt="Itch" className="w-8 h-8 sm:w-12 sm:h-12" title="Itch" />
				)}
				{project.platforms?.includes("roblox") && (
					<img src="/icons/roblox.svg" alt="Roblox" className="w-8 h-8 sm:w-12 sm:h-12" title="Roblox" />
				)}
			</div>

			{/* Thumbnail */}
			{project.thumbnail && (
				<img
					src={project.thumbnail}
					alt={`${project.title} thumbnail`}
					className="w-32 h-32 sm:w-44 sm:h-44 object-cover rounded-md flex-shrink-0 shadow-inner transition-transform duration-300 group-hover:scale-105"
				/>
			)}

			{/* Text Content */}
			<div className="flex flex-col justify-center items-center sm:items-start">
				<h2 className={`text-2xl sm:text-3xl font-bold ${project.color} mb-1 transition-opacity duration-300 group-hover:opacity-90`}>
					{project.title}
				</h2>
				<p className="text-gray-300 text-base sm:text-lg transition-opacity duration-300 group-hover:opacity-70">
					{project.subtitle}
				</p>
				<p className="italic text-sm text-gray-400 mt-1 transition-opacity duration-300 group-hover:opacity-60">
					{project.engine}
				</p>
			</div>

			{/* Year - Bottom Right Corner */}
			{project.year && (
				<div className={`${project.color} absolute bottom-3 right-3 bg-black/50 font-bold text-lg sm:text-2xl px-2 py-1 rounded shadow-md group-hover:animate-pulse`}>
					{project.year}
				</div>
			)}
		</div>
	);
}